import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import * as api from "./api";

const KEY = ["admin", "prompts"] as const;

export function usePrompts(scope?: string) {
  return useQuery({
    queryKey: [...KEY, { scope }],
    queryFn: () => api.listPrompts(scope),
  });
}

export function useUpsertPrompt(scope?: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (v: { key: string; payload: api.UpsertPromptPayload }) =>
      api.upsertPrompt(v.key, v.payload, scope),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}

export function usePreviewPrompt(scope?: string) {
  return useMutation({
    mutationFn: (v: { key: string; payload: api.PreviewPromptPayload }) =>
      api.previewPrompt(v.key, v.payload, scope),
  });
}
